import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import hexToRgba from 'hex-to-rgba';
// import { motion, AnimatePresence } from 'framer-motion';
import moment from 'moment';

import BillDetailPanel from './BillDetailPanel';
import BillViewerPanel from './BillViewerPanel';
import { GripVertical, LucideX } from 'lucide-react';
import { apiPOSTReq, getPreSignedS3Url } from '../../../../Utils/api';
import environment from '../../../../environment';
import { ErrorAlert } from '../../../Reusable/Alert';
import { toNumberStr } from '../../../../Utils/util';
import DragImg from '../../../../Images/drag.svg';
import SVGIcon from '../../../Reusable/SVGIcon';
import { Flex } from '../../../Reusable/Container';
import AionLogo from '../../../Reusable/Image';
import LucideIcon from '../../../Reusable/Button';
import { initial } from 'underscore';

// Styled components for the layout
const BillPaymentsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden; /* Prevent scrolling during resize */
  padding: 50px 50px 0 50px;
`;

const LeftPanelContainer = styled.div`
  width: ${props => props.width}px;
  height: 100%;
  position: sticky;
  top: 30px;
  flex-shrink: 0;
  transition: width 0s ease;
  overflow-y: hidden; /* Prevent scrolling in left panel */
  /* box-shadow: ${props => props.showShadow && `0px 0px 32px 0px rgba(102, 102, 102, 0.16)`}; */
  padding-bottom: 50px;
`;

const RightPanelContainer = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
  margin-left: 24px;
  overflow-y: auto; /* Only the right panel should scroll */
`;

const ResizeDivider = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${props => props.position}px;
  width: 0px;
  background-color: ${props => hexToRgba(props.theme.colors.primary3 || '#ccc', 0.1)};
  cursor: col-resize;
  z-index: 10;
  transition: left 0s ease;
`;

const ResizeHandle = styled.div`
  position: absolute;
  top: 50%;
  left: ${props => props.position + 52}px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;
  z-index: 11;
  transition: left 0s ease, opacity 0s ease;
  opacity: ${props => props.isVisible ? 1 : 0};
`;

const HeaderContainer = styled(Flex)`
  padding: 10px 20px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
`;

class BillPaymentsLayout extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            leftPanelWidth: 700,
            isDragging: false,
            initialX: 0,
            initialWidth: 850,
            viewMode: true,
            payMode: false,
            lastScrollPosition: 0,
            isScrollingDown: false,
            bill: this.props.bill,
            scheduledPayments: [],
            loading: true,
            initialPageLoad: true,
            billAmtPaid: false
        };
        
        this.containerRef = React.createRef();
        this.rightPanelRef = React.createRef();
        this.scrollTimeoutRef = null;
    }
    
    componentDidMount() {
        const { id } = this.props.match.params;

       if (id) {
            this.getBill(id, (bill) => this.loadBill(bill)); 
        } else if (this.props.bill?.id) {
            this.loadBill(this.props.bill);
        } else if (this.props.location?.state) {
            var { bill, inboxItem } = this.props.location.state;
            if (inboxItem) {
                this.setState({ inboxItem: inboxItem });
                this.getParsedInvoice(inboxItem);
            } else if (bill) {
                this.loadBill(bill);
            }
        }

        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
    }

    componentDidUpdate(prevProps) {
        // Check if view mode has changed, refetch payments
        if (this.props.match?.params?.id !== prevProps.match?.params?.id) {
            const { id } = this.props.match.params;
            if(id) this.getBill(id, (bill) => this.loadBill(bill));
        }

    }
    
    componentWillUnmount() {
        // Clean up event listeners
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        
        // Clear any pending timeouts
        if (this.scrollTimeoutRef) {
            clearTimeout(this.scrollTimeoutRef);
        }
    }

    loadBill(bill) {
        console.log("loadBill", bill?.vendorId);
        if ((bill || {}).previewDocumentUrls && bill.previewDocumentUrls.length > 0) {
            getPreSignedS3Url({ url: bill.previewDocumentUrls[0].uri }, (err, preSignedUrl) => {
                if (!err) {
                    this.setState({ billUrl: preSignedUrl });
                } else {
                    console.log({ description: err });
                }
            })
        }
        this.getVendor(bill?.vendorId, (v) => {
            console.log("loadBill getVendor v", v)
            this.setState({ bill: bill, vendor: v })
        });
        this.getSchldPmts(bill?.id);
    }

    getBill = (id, callback) => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/getBill`, { "BankProvider": environment.bankProvider.crb }, { billId: id }, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result && data.bill) {
                    if(callback) callback(data.bill);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                this.setState({ loading: false });
                console.log("ERRR /payables/bills/getBill", error, err, resp)
                ErrorAlert({ description: error.message });
            }
        })
    }

    getParsedInvoice = (inboxItem) => {
        inboxItem = inboxItem || {}
        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/getParsedInvoice`, {}, { BillInboxItemId: inboxItem.id }, (err, resp) => {
            try {
                const data = resp || {}
                var parsedInvoice = data.parsedInvoice || {}
                var vendorReference = parsedInvoice.vendorReference
                if (data.result) {
                    // Create a bill and vendor obj
                    var bill = {
                        "invoiceNumber": parsedInvoice.docNumber,
                        "billDate": parsedInvoice.transactionDate ? moment.utc(parsedInvoice.transactionDate).format("YYYY-MM-DD") : null,
                        "dueDate": parsedInvoice.dueDate ? moment.utc(parsedInvoice.dueDate).format("YYYY-MM-DD") : null,
                        "amount": parsedInvoice.totalAmt || parsedInvoice.balance,
                        "balance": parsedInvoice.balance,
                        "subTotal": parsedInvoice.subTotal,
                        "tax": parsedInvoice.tax,
                        "discount": parsedInvoice.discount,
                        "line": parsedInvoice.lineItems ? parsedInvoice.lineItems : [],
                        "previewDocumentUrls": [
                            {
                                "uri": parsedInvoice.attachmentUrl
                            }
                        ],
                        "ponumber": parsedInvoice.ponumber,
                        "vendorName": inboxItem.vendorName || vendorReference?.companyName,
                        "vendorId": inboxItem.vendorId || vendorReference?.id,
                        "status": "Unpaid"
                    }
                    var vendor = {
                        vendorName: inboxItem.vendorName || vendorReference?.companyName,
                        id:  inboxItem.vendorId || vendorReference?.id,
                        primaryEmail: inboxItem.sender,
                        address: vendorReference?.address || (parsedInvoice.billingAddress?.line1 && parsedInvoice.billingAddress)
                    }
                    
                    getPreSignedS3Url({ url: bill.previewDocumentUrls[0].uri }, (err, preSignedUrl) => {
                        if(vendorReference?.id) {
                            this.getVendor(vendorReference?.id, (v) => this.setState({ bill: bill, billUrl: preSignedUrl, vendor: v || vendor }));
                        } else {
                            this.setState({ bill: bill, billUrl: preSignedUrl, vendor: vendor, loading: false });
                        }
                        
                    })
                } else {
                    var errMsg = data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later"
                    if (data.parseStatus) {
                        errMsg = "This bill is being processed by our AI Engine, please check back in a few minutes."
                    }
                    throw Error(errMsg)
                }
            } catch (error) {
                this.setState({ loading: false });
                console.log("ERRR /payables/bills/getParsedInvoice", error, err, resp)
                ErrorAlert({ description: error.message })
                this.setState({ loading: false })
            }
        })
    }

    getVendor = (id, callback) => {

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendor`, {}, { vendorId: id }, (err, resp) => {
            try {
                this.setState({ loading: false });
                const data = resp
                if (data.result && data.vendor) {
                    if(callback) callback(data.vendor);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                this.setState({ loading: false });
                console.log("ERRR /payables/vendors/getVendor", error, err, resp)
                ErrorAlert({ description: error.message });
                if(callback) callback(null);
            }
        })
    }

    saveBill = (options, callback) => {
        options = options || {};
        var { bill, inboxItem } = this.state;
        if(options.bill) bill = options.bill;

        if (isNaN(bill.amount)) {
            ErrorAlert({ description: "Please enter an amount for this bill." })
            return
        }
        if (!bill.invoiceNumber) {
            ErrorAlert({ description: "Please enter a bill no. for this bill." })
            return
        }
        if (!bill.dueDate) {
            ErrorAlert({ description: "Please select a due date for this bill." })
            return
        }

        const body = {
            bill: bill,
        }

        if (inboxItem) body.billInboxItemId = inboxItem.id

        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/save`, {}, body, (err, resp) => {
            this.setState({ saveLoading: false, payLoading: false })
            try {
                const data = resp || {};
                if (data.result) {
                    console.log("BillPaymentsLayout", data);
                    this.setState({ bill: data.bill, inboxItem: null, billAmtPaid: data.bill?.balance <= 0, billBalance: data.bill?.balance });
                    if (callback) callback(bill, true);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/bills/save", error, err, resp)
                ErrorAlert({ description: error.message })
                if (callback) callback(error.message)
            }
        })
    }

    getSchldPmts = (billId) => {
        // This includes both pending approval and scheduled statuses
        var body = {
            "billId": billId,
            "viewBy": "APPROVAL_SCHEDULED"
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/getPayments`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            this.setState({ submitLoading: false, payBillLoading: false })
            try {
                const data = resp || {}
                if (data.result) {
                    var scheduledPayments = data.achTransfersList || [];
                    scheduledPayments = scheduledPayments.concat(data.wireTransfersList || []);
                    scheduledPayments = scheduledPayments.concat(data.instantTransfersList || []);
                    var scheduledAmt = 0;
                    scheduledPayments.forEach(pmnt => {
                        scheduledAmt += parseFloat(pmnt.amount)
                    });
                    this.setState({ scheduledPayments: scheduledPayments });

                    // Check if bill has been fully paid
                    var payments = this.state.bill?.payments || [];
                    var paymentsTotal = 0;
                    var paidpayments = payments.filter(pmt => ["Initiated", "Created", "Pending", "Processing", "Paid", "On Hold", "Compliance Alert", "Completed"].includes(pmt.paymentStatus));
                    paidpayments.forEach(pmnt => { paymentsTotal += parseFloat(pmnt.amount) });
                    

                    var billBalance = this.state.bill?.amount - (paymentsTotal + scheduledAmt);
                    var billAmtPaid = billBalance <= 0;
                    // console.log("getSchldPmts", paymentsTotal, scheduledAmt, billBalance);
                    if(this.state.initialPageLoad) {
                        this.setState({ viewMode: billAmtPaid, payMode: !billAmtPaid, initialPageLoad: false, billAmtPaid: billAmtPaid, billBalance: billBalance });
                    } else {
                        this.setState({ billAmtPaid: billAmtPaid, billBalance: billBalance });
                    }

                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("PayBill getSchldPmts ERRR ", error, err, resp);
            }
        })
    }

    updateBillInboxItem = (options, callback) => {
        var { inboxItem } = options;

        var body = {
            billInboxItem: inboxItem
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/saveBillInboxItem`, {}, body, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    this.setState({ inboxItem: inboxItem });
                    
                    if (callback) callback(true);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
                if (callback) callback(error.message)
            }
        })
    }

    updateBillVendor = (options) => {
        options = options || {};
        var { bill, vendor } = this.state;

        if (options.bill) bill = options.bill;
        if (options.vendor) vendor = options.vendor;

        var updateState = { vendor, bill };

        if(options.updateInboxItem) {
            console.log("updateBillVendor layout", options);
            this.updateBillInboxItem({ inboxItem: options.inboxItem });
        }

        this.setState(updateState);
    }

    handleMouseOverPDFChange = (isOver) => {
        this.setState({ isMouseOverPDF: isOver });
    };

    // Handle pay card toggle
    handlePayCardToggle = () => {
        const newPayMode = !this.state.payMode;
        this.setState({ 
            payMode: newPayMode,
            viewMode: !newPayMode
        });
        
        // Notify parent component about mode change
        if (this.props.onViewModeChange) {
            this.props.onViewModeChange(!newPayMode, newPayMode);
        }
    };

    // Enhanced scroll detection for transitioning FROM pay mode TO view mode
    handleScroll = () => {
        // Only handle scrolling when in pay mode AND mouse is over PDF container
        if (!this.state.payMode || !this.rightPanelRef.current || !this.state.isMouseOverPDF) return;
        
        const currentScrollTop = this.rightPanelRef.current.scrollTop;
        const scrollingDown = currentScrollTop > this.state.lastScrollPosition;
        
        this.setState({ lastScrollPosition: currentScrollTop });
        
        if (scrollingDown) {
            // Set flag to indicate downward scrolling
            this.setState({ isScrollingDown: true });
            
            // Clear any existing timeout
            if (this.scrollTimeoutRef) {
                clearTimeout(this.scrollTimeoutRef);
            }
            
            // Set a timeout to detect if scrolling has slowed or stopped
            this.scrollTimeoutRef = setTimeout(() => {
                // If still in scroll down state after timeout and in pay mode, switch to view mode
                if (this.state.isScrollingDown && this.state.payMode && this.state.isMouseOverPDF) {
                    this.setState({ 
                        payMode: false,
                        viewMode: true,
                        isScrollingDown: false
                    });
                    
                    // Notify parent
                    if (this.props.onViewModeChange) {
                        this.props.onViewModeChange(true, false);
                    }
                }
            }, 10); // Short timeout to be responsive to slow scrolling
        } else {
            this.setState({ isScrollingDown: false });
        }
    };

    // Handle resize divider drag
    handleMouseDown = (e) => {
        // Prevent default behavior
        e.preventDefault();

        // Store initial position and width
        this.setState({
            isDragging: true,
            initialX: e.clientX,
            initialWidth: this.state.leftPanelWidth
        });

        // Add event listeners for drag and end
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
    };

    handleMouseMove = (e) => {
        if (!this.state.isDragging) return;

        const containerRect = this.containerRef.current.getBoundingClientRect();

        // Calculate delta and new width
        const deltaX = e.clientX - this.state.initialX;
        // Reserve 750px for PayBillCard + 24px margin + some buffer = ~800px total
        const maxLeftPanelWidth = containerRect.width - (this.state.viewMode ? 450 :700);
        const newWidth = Math.max(450, Math.min(this.state.initialWidth + deltaX, maxLeftPanelWidth));

        this.setState({ leftPanelWidth: newWidth });
    };

    handleMouseUp = () => {
        this.setState({ isDragging: false });
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
    };

    render() {
        const {
            onBack,
            onSave,
            onPay,
            onClose
        } = this.props;
        
        const {
            bill,
            inboxItem,
            vendor,
            billUrl,
            leftPanelWidth,
            viewMode,
            payMode,
            loading,
            scheduledPayments,
            billAmtPaid,
            billBalance
        } = this.state;

        return (
            <BillPaymentsContainer ref={this.containerRef}>
                <HeaderContainer centerH between>
                        <AionLogo symbol logoHeight="24px" height='20px' margin='0px' />
                        <LucideIcon icon={LucideX}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (onClose) onClose(e)
                                else window.history.back()
                            }}
                        />
                </HeaderContainer>

                {/* Left Panel - Bill Details */}
                <LeftPanelContainer
                    width={leftPanelWidth}
                    initial={{ opacity: 0 }}
                    animate={{
                        opacity: 1,
                        width: leftPanelWidth
                    }}
                    transition={{ duration: 0.3 }}
                    showShadow={viewMode}
                >
                    <BillDetailPanel
                        key={bill?.invoiceNumber}
                        width={leftPanelWidth}
                        loading={loading}
                        inboxItem={inboxItem}
                        bill={bill}
                        vendor={vendor}
                        onBack={onBack}
                        onSave={onSave}
                        viewMode={viewMode}
                        toggleViewPayMode={(bill) => {
                            this.handlePayCardToggle();
                        }}
                        saveBill={this.saveBill}
                        getBill={this.getBill}
                        scheduledPayments={scheduledPayments}
                        getSchldPmts={this.getSchldPmts}
                        updateBillVendor={this.updateBillVendor}
                        billAmtPaid={billAmtPaid}
                        billBalance={billBalance}
                    />
                </LeftPanelContainer>

                {/* Resizable Divider */}
                <ResizeDivider
                    position={leftPanelWidth}
                    onMouseDown={this.handleMouseDown}
                />

                {/* Resize Handle */}
                <ResizeHandle
                    position={leftPanelWidth}
                    onMouseDown={this.handleMouseDown}
                    isVisible={viewMode || payMode}
                    initial={{ opacity: 0 }}
                    animate={{
                        opacity: viewMode ? 1 : 0,
                        left: `${leftPanelWidth + 52}px`
                    }}
                    transition={{ duration: 0.2 }}
                >
                    {/* <GripVertical /> */}
                    <SVGIcon 
                        src={DragImg} 
                        height='24px' 
                        width='24px' 
                        strokeWidth='0.4px' 
                        color={hexToRgba(this.props.theme.colors.primary2, 0.4)}
                        fill={hexToRgba(this.props.theme.colors.primary2, 0.4)} 
                    />
                </ResizeHandle>

                {/* Right Panel - Pay Bill and PDF Viewer */}
                <RightPanelContainer
                    ref={this.rightPanelRef}
                    onScroll={this.handleScroll}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                >
                    <BillViewerPanel
                        key={payMode+bill?.id+vendor?.id}
                        leftPanelWidth={leftPanelWidth}
                        bill={bill}
                        billAmtPaid={billAmtPaid}
                        billBalance={billBalance}
                        vendor={vendor}
                        billUrl={billUrl}
                        onPay={(callback) => {
                            this.getBill(bill?.id, (bill => {
                                this.setState({ bill });
                                if(callback) callback(bill);
                                this.handlePayCardToggle();
                            }));
                        }}
                        getSchldPmts={this.getSchldPmts}
                        viewMode={viewMode}
                        payMode={payMode}
                        saveBill={this.saveBill}
                        onPayCardToggle={(bill) => {
                            // if(bill) this.setState({ bill });
                            this.handlePayCardToggle();
                        }}
                        loading={loading}
                        updateBillVendor={this.updateBillVendor}
                        onMouseOverPDFChange={this.handleMouseOverPDFChange}
                        scrollThresholdPercentage={10}
                    />
                </RightPanelContainer>
            </BillPaymentsContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(BillPaymentsLayout)));